import { useMemo } from "react";
import { type GridColumnProps } from "@progress/kendo-react-grid";

import { useStateLevelExtracts } from "@/queries/stateLevelExtractsApi";
import { type ExtractRequest } from "@/models/extract";

import Card from "@/components/shared/Card";
import KendoTableClientState from "@/components/shared/tables/KendoTableClientState";
import ExtractStatusCell from "@/components/extracts/ExtractsCard/ExtractStatusCell";
import TableDateCell from "@/components/shared/tables/TableDateCell";
import CategoryFilterCell from "@/components/shared/tables/CategoryFilterCell";
import { DateFilterCell } from "@/components/shared/tables/GridFilterCells";

const REFETCH_INTERVAL = 10000;

const statusOptions = ["Complete", "Request Raised"];

export default function StateLevelExtractsCard() {
  const { data, error, isLoading } = useStateLevelExtracts(REFETCH_INTERVAL);

  const columns: GridColumnProps[] = useMemo(
    () => [
      {
        id: "FileName",
        field: "FileName",
        title: "Filename",
        width: 250,
      },
      {
        id: "RequestDate",
        field: "RequestDate",
        title: "Date Requested",
        filter: "date",
        cells: {
          data: TableDateCell,
          filterCell: (props) => DateFilterCell(props, "Date Requested"),
        },
      },
      {
        id: "RequestorUsername",
        field: "RequestorUsername",
        title: "Requested By",
        width: 250,
      },
      {
        id: "FileSizeBytes",
        field: "FileSizeBytes",
        title: "File Size (bytes)",
        filter: "numeric",
      },
      {
        id: "ExtractStatus",
        field: "ExtractStatus",
        title: "Status",
        cells: {
          data: ({ dataItem, tdProps }) =>
            ExtractStatusCell(dataItem as ExtractRequest, tdProps, "/extracts/state"),
          filterCell: (props) => CategoryFilterCell(props, [...statusOptions]),
        },
      },
    ],
    []
  );

  return (
    <Card className="mt-4 mb-3 no-padding card-border">
      <div
        className="text-white p-3 d-flex align-items-center gap-2"
        style={{
          background: "var(--color-p3)",
          fontWeight: 500,
          borderTopLeftRadius: "inherit",
          borderTopRightRadius: "inherit",
        }}
      >
        State Level Exports
      </div>
      {!isLoading && (
        <KendoTableClientState
          data={data ?? []}
          columns={columns}
          error={error}
          initialSort={[{ field: "RequestDate", dir: "desc" }]}
        />
      )}
    </Card>
  );
}
